import React from 'react';

const MapView = () => {
  return (
    <div className="w-full h-[450px] mt-10 rounded-lg overflow-hidden shadow-lg">
<iframe
  title="Google Map"
  src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1957.2911721376593!2d77.95411014379638!3d11.144450997990804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTHCsDA4JzQwLjAiTiA3N8KwNTcnMTguOCJF!5e0!3m2!1sen!2sin!4v1751306279211!5m2!1sen!2sin"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>
    </div>
  );
};

export default MapView;
